var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-spinner-dots',{staticStyle:{"position":"absolute","left":"45%","top":"45%"},attrs:{"size":"10%","thickness":"1px","color":"primary"}})}
var staticRenderFns = []

export { render, staticRenderFns }